module.exports = __webpack_public_path__ + "img/sportradar.54b9f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/sportradar.png
// module id = Eqw1
// module chunks = 39 44